import { EmptyProps } from "@/Common/Components/BaseReactComponent";
import { Modal } from "@/Common/Components/Modals/Modal";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

class SessionTimeoutWarningPopup extends React.Component<EmptyProps, never> {
    public render(): JSX.Element {
        return (
            <Modal
                onClose={null}
                showOverlay
                disableOverlayClose
                title={cacheStore.GetString("SessionExpirationLabel")}
                width={400}
                footer={this.renderModalFooter()}
            >
                <p>{cacheStore.GetString("SessionWarningLabel")}</p>
            </Modal>
        );
    }

    private renderModalFooter(): JSX.Element {
        return (
            <div className="flex-container" style={{ "justifyContent": "flex-end" }}>
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => this.OnOKClick()}
                >
                    {cacheStore.GetString("OKLabel")}
                </button>
            </div>
        );
    }

    public OnOKClick(): void {
        var operation = new LocalEvent(LocalOperations.MainComponentViewOperations.DisplaySessionWarningPopup);
        MainComponentStateDispatcher.dispatch(operation);
    }
}

export { SessionTimeoutWarningPopup };
